// membershipAPI.js
import { firestore } from "../firebase"; // Adjust the path if necessary
import { collection, query, where, onSnapshot, orderBy, limit, startAfter, getDocs } from 'firebase/firestore';


export const fetchPendingRequests = (setRequests, tenantId = null) => {
  const requestsRef = collection(firestore, "MembershipRequests");
  let q = query(requestsRef, where("status", "==", "pending"));
  
  // Add tenant filter if tenantId is provided (for tenant-based admins)
  if (tenantId) {
    q = query(requestsRef, where("status", "==", "pending"), where("tenantId", "==", tenantId));
  }

  // Listen to real-time updates
  const unsubscribe = onSnapshot(q, (snapshot) => {
    setRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  });

  // Return the unsubscribe function for cleanup
  return unsubscribe;
};

export const fetchInitialItems = (setData, setFilteredData, setLoadingMore, setLastVisible, tenantId = null) => {
    setLoadingMore(true);
  
    const membershipCollectionRef = collection(firestore, "MembershipMaster");
    let q = query(
      membershipCollectionRef,
      orderBy('membershipEndDate'),
      limit(5) // Fetch the first 5 items
    );
    
    // Add tenant filter if tenantId is provided
    if (tenantId) {
      q = query(
        membershipCollectionRef,
        where("tenantId", "==", tenantId),
        orderBy('membershipEndDate'),
        limit(5)
      );
    }
  
    // Real-time listener to fetch initial data
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const newData = [];
      querySnapshot.forEach((doc) => {
        newData.push({ id: doc.id, ...doc.data() });
      });
  
      setData(newData);
      console.log("Fetched data:", newData); 
      setFilteredData(newData);
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]); // Save last visible for pagination
      setLoadingMore(false);
    });
  
    // Return the unsubscribe function for cleanup
    return unsubscribe;
  };
  

  export const fetchMoreItems = async (setData, setLastVisible, setLoadingMore, loadingMore, lastVisible, setFilteredData, tenantId = null) => {
    if (loadingMore || !lastVisible) return;
  
    setLoadingMore(true);
  
    try {
      const membershipCollectionRef = collection(firestore, "MembershipMaster");
      let q = query(
        membershipCollectionRef,
        orderBy('membershipEndDate'),
        startAfter(lastVisible), // Start after the last fetched item
        limit(5) // Fetch next 5 items
      );
      
      // Add tenant filter if tenantId is provided
      if (tenantId) {
        q = query(
          membershipCollectionRef,
          where("tenantId", "==", tenantId),
          orderBy('membershipEndDate'),
          startAfter(lastVisible),
          limit(5)
        );
      }
  
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        const moreItems = [];
        querySnapshot.forEach((doc) => {
          moreItems.push({ id: doc.id, ...doc.data() });
        });
  
        setData((prevData) => [...prevData, ...moreItems]); // Append new data to existing data
        setFilteredData((prevData) => [...prevData, ...moreItems]);
        console.log("Fetched data:", moreItems);
        setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]); // Update the last visible document
      } else {
        setLastVisible(null); // No more items to fetch
      }
    } catch (error) {
      console.error('Error fetching more items:', error);
    }
  
    setLoadingMore(false);
  };
